"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("@hotmart/request");
const productHeaderInterceptor = (config) => {
    var _a;
    if ((_a = config.headers) === null || _a === void 0 ? void 0 : _a['x-product-id']) {
        delete config.headers.Club;
    }
    return config;
};
request_1.axios.interceptors.request.use(productHeaderInterceptor);
exports.default = productHeaderInterceptor;
